<div #container class="zoomable-container">
  <img
    [src]="src"
    [alt]="alt"
    class="zoomable-image"
    [style.transform]="'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + zoom + ')'"
    draggable="false"
  />
</div>
